import axios from "axios";
import React from "react";
import { toast } from "react-toastify";
import { E_LEARNING_API_BASE_URL,  url } from "../config/config";
import { CODE, VALIDATION_MESSAGE } from "../constants/Constants";

const apiinstance = axios.create({
  baseURL:E_LEARNING_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
    //"Authorization": "Bearer " + localStorage.getItem('access-token'),
    "device_type": "web"
  }
})

// Add a request interceptor to dynamically add the token to every request
apiinstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const POSTAPIaks = (URL:string, params:any,toastStatus:any=true) =>{
  const promise = apiinstance.post(URL, params,{
    validateStatus : status => status >= 200 && status < 600
  })

  const dataPromise = promise.then((response) => response).then((response) =>{
      if(response?.status === 200 || response?.status === 201){
        if(toastStatus){toast.success(response.data?.message)}
        
        return response.data;
      }else{
        toast.error(response.data?.message)
        return response?.data;
      }
  })
  return dataPromise;
}


export const POSTAPI = (URL: string, params: any,toastStatus:any=true) => {
  console.log("key : " , localStorage.getItem('access-token'));

  const promise = apiinstance.post(URL, params, {
    validateStatus: status => status >= 200 && status < 600
  });
  const dataPromise = promise.then((response) => response).then((response) => {
    
    if (response?.status === CODE?.OK_CODE || response?.status ===  CODE?.CREATED) {
      if(toastStatus){toast.success(response.data?.message)}
      if (response?.data?.status) {
    //    toast.success(response.data?.message);
        return response.data;
      }
      else {
        toast.error(response.data?.message);
        return response.data;
      }
    }
    else if (response?.status === CODE?.BAD_REQUEST_CODE) {
      toast.error(response.data?.message);
      return response?.data;
    }
    else if (response?.status === CODE?.UNAUTHORIZED_CODE) {
      toast.error(response.data?.message)
      // localStorage.clear()
      // sessionStorage.clear()
      //window.location.href = url + '/login'
    }
    else if (response?.status === CODE?.INTERNAL_SERVER_ERROR) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else if (response?.status === CODE?.VALIDATION_CODE) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else {
      toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
    }
  }).catch((error) => {
    // return error;   
    toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
  });
  return dataPromise;
};


export const GETAPI = (URL:string, params: any={}) =>{
  const promise = apiinstance.get(URL,params)

  const dataPromise = promise.then((response) => response).then((response) =>{
    //console.log(response,' GET API Response')
      if(response?.status === 200 || response?.status === 201){
      //  toast.success(response.data?.message)
        return response.data;
      }else{
        toast.error(response.data?.message)
        return response?.data;
      }
  })
  return dataPromise;
}